(function ($) {
	$(document).ready(function () {
			let pagetop = '#pagetop';
			let footer = '.site-footer';

			$(pagetop).hide();
			$(footer).css('position','relative');

			$(window).on("scroll", function () {
					if ($(this).scrollTop() > 500) {
							$(pagetop).slideDown("fast");
					} else {
							$(pagetop).slideUp("fast");
					}
					let scrollHeight = $(document).height();
					let scrollPosition = $(window).height() + $(window).scrollTop();
					let footHeight = $(footer).innerHeight();
					console.log(footHeight);
					if (scrollHeight - scrollPosition <= footHeight) {
							$(pagetop).css({//フッターに到達したら
									"position": "absolute",
									"bottom": footHeight + 1
							});
					} else { //フッターに到達する前
							$(pagetop).css({
									"position": "fixed",
									"bottom": "0"
							});
					}
			});
			$(pagetop).on('click',function() {
					$('body,html').animate({
							scrollTop: 0
					}, 400);
					return false;
			});
	});

	// #で始まるアンカーをクリックした場合にスクロール処理
	jQuery('a[href^="#"]:not(a.notscroll)').on('click',function () {
			let speed = 500;
			let href = jQuery(this).attr("href");
			let target = jQuery(href == "#" || href == "" ? 'html' : href);
					target = target.offset().top;
			let headerHeight = $("#masthead").innerHeight();
			let position = target - headerHeight;
			jQuery("html, body").animate({ scrollTop: position }, speed, "swing");
			return false;
	});
})(jQuery);
